import React from 'react';

import ChoiceButtonContents from './ChoiceButtonContents';
import { useAnimationStageContext } from './AnimationStageContext';

const SpinChoiceButton = () => {
  const { stageKey, getSelectedSpinChoice } = useAnimationStageContext();

  if (!stageKey) {
    return null;
  }

  const { label, icon } = getSelectedSpinChoice();

  return (
    <ChoiceButtonContents label={label} id={`${stageKey}-spin-choice-contents`}>
      {icon}
    </ChoiceButtonContents>
  );
};

export default SpinChoiceButton;
